import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import { BulkActionProps, BulkDeleteButton, DateInput, List, ListProps, TextInput } from 'react-admin';
import { DynamicCardList } from './DynamicCardList';
import { DynamicCardDatagrid } from './DynamicCardDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { DynamicCard } from './DynamicCard';

export * from './DynamicCard';
export * from './DynamicCardCreate';
export * from './DynamicCardDatagrid';
export * from './DynamicCardEdit';
export * from './DynamicCardList';
export * from './DynamicCardShow';

const DynamicCardsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'name', header: 'Name' },
	{ key: 'link', header: 'Link' },
	{ key: 'description', header: 'Description' },
	{ key: 'imageUrl', header: 'Image' }
];

export const DynamicCardsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: DynamicCard) => entity;

	const dynamicCardsFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('קטגוריות דינאמיות', exportFields, exportDataMapper)}
				{...props}
				filters={dynamicCardsFilter}
				bulkActionButtons={<DynamicCardsBulkActionButtons/>}
				title="DYNAMIC_CARDS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <DynamicCardList/> : <DynamicCardDatagrid/>}
			</List>
		</Fragment>
	);
};
